<template>
  <v-dialog
    v-model="showingFullImage"
    fullscreen
  >
    <div
      :style="style"
      v-touch="{
        left: () => nextImg(),
        right: () => prevImg()
      }"
    >
      <v-layout
        wrap
        fill-height
        align-center
        justify-center
      >
        <v-flex
          xs1
          pa-4
          text-xs-right
        >
          <v-btn fab dark flat @click="prevImg" small style="z-index:1;">
            <v-icon large>chevron_left</v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          xs7
          :style="fullContainerStyle"
        >
          <!-- preload images -->
          <img
            v-if="preloadImg1"
            :src="fullPath + images[preloadImg1].image"
            style="width: 30px;position: absolute; left: 10000px"
          />
          <img
            v-if="preloadImg2"
            :src="fullPath + images[preloadImg2].image"
            style="width: 30px;position: absolute; left: 10000px"
          />
          <!-- /preload images -->

          <div class="full-container">
            <div :class="'full-container-img-outer'">
              <img
                :src="fullPath + fullImage1.image"
                :class="' ' + (
                  image1Transparent ? ' img-transparent' : ''
                )"
              />
              <img
                :src="fullPath + fullImage2.image"
                :class="' ' + (
                  image2Transparent ? ' img-transparent' : ''
                )"
              />
            </div>
            <div :class="'full-container-img-outer' + (
              image2Transparent ? ' img-transparent' : ''
              )"
            >
            </div>
          </div>
        </v-flex>

        <v-flex
          xs1
          pa-4
          text-xs-left
        >
          <v-btn fab dark flat small @click="nextImg" style="z-index:1;">
            <v-icon large>chevron_right</v-icon>
          </v-btn>
        </v-flex>

        <v-flex
          xs3
          pa-5
        >
          <v-layout v-if="!mobile" wrap text-xs-center mt-3 mb-3>

            <v-flex xs12 pb-5>
              <v-btn fab flat dark small @click="closeFull" style="z-index:1;">
                <v-icon large>close</v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs6 py-3 style="width: 100%;">
              <img
                :src="fullPath + previewSideImage2.image"
                style="width:calc(100% - 20px); margin: 10px; border-radius: 8px;"
                @click="nextImg();"
              />
            </v-flex>

            <v-flex xs6 pt-3 style="width: 100%;">
              <img
                :src="fullPath + previewSideImage3.image"
                style="width:calc(100% - 20px); margin: 10px; border-radius: 8px;"
                @click="nextImg();nextImg();"
              />
            </v-flex>

            <v-flex xs12 pt-5 text-xs-center>
              <span style="font-size: 18px;">{{ selectedImageIndex + 1 }} / {{ images.length }}
              </span>
            </v-flex>


          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-dialog>
</template>

<script>
import methods from './../methods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})


export default {
  name: 'ObjectImagesFull',

  data: () => {
    return {

    }
  },

  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    compact: {
      type: Boolean,
      default: false
    },
    imgFolder: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    fullPath () {
      return this.s3url + this.imgFolder + '/'
    },

    homepage () {
      return this.$route.name === 'homewlang' || this.$route.name === 'home'
    },

    fullContainerStyle () {
      return {
        height: (this.windowHeight * 1) + 'px'
      }
    },

    style () {
      return {
        'z-index': 1500,
        height: this.windowHeight + 'px',
        width: this.windowWidth + 'px',
        position: 'fixed',
        left: 0,
        top: 0,
        'background-color': 'rgba(255, 255, 255, 1)'
      }
    }
  },

  created () {
    window.addEventListener('keyup', this.keyupOnImageView)
  },

  destroyed () {
    window.removeEventListener('keyup', this.keyupOnImageView)
  },

  methods: {
    ...methods,

    keyupOnImageView (e) {
      if (e.code === 'ArrowLeft') {
        this.prevImg()
      } else if (e.code === 'ArrowRight') {
        this.nextImg()
      }
    }
  }
}
</script>

<style>

</style>
